import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import React from 'react';
import { useParams } from 'react-router-dom';
import { httpService } from '../../../services/http.service';
import { IMoveMoneyReviewResponse, IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { MoveMoneyTypes } from '../consts';
import { endpointManager } from '../../../services/endpoint.service';

interface IPostWireMfaVerification {
    answer: string;
    mfaData: IMoveMoneyReviewResponse | null;
    billId?: string;
}

export const postMfaVerification = () => {
  const { moveType } = useParams();
  const { postMfaVerifyForWireOutUrl, postMfaVerifyForAchOutUrl, postMfaVerifyForInternationalWireOutUrl } = endpointManager();

  return useMutation(
    'postWireMfaVerification',
    async ({ answer, mfaData, billId }: IPostWireMfaVerification) => {
      let url = '';
      switch (moveType) {
        case MoveMoneyTypes.WIRE_OUT:
          url = postMfaVerifyForWireOutUrl(billId);
          break;

        case MoveMoneyTypes.INTERNATIONAL_WIRE_OUT:
          url = postMfaVerifyForInternationalWireOutUrl(billId);
          break;

        case MoveMoneyTypes.ACH_OUT_TRANSFER:
          url = postMfaVerifyForAchOutUrl(billId);
          break;

        default:
          break;
      }

      const res = await httpService.post(url, { ...mfaData, answer });
      return res.data;
    },
    {
      onError: (error: IServerErrorResponse) => {
        const { localizedMessage } = flattenServerErrorResponse(error);
        toast(<LiliNotification undismissable type={LiliNotificationType.ERROR} text={localizedMessage} id='vendorDetailsError' />, { ...LiliToastDefaultConfig });
      },
    },
  );
};
